import { atom } from "recoil";

export const AlertState = atom({
    key: "AlertState",
    default: { msg: '', type: '', description: '' }
})

export const initialConfirmationState = {
    open: false,
    confirmed: false,
    component: null,
    msg: ""
}

export const Confirmation = atom({
    key: "Confirmation",
    default: initialConfirmationState
})

export const HttpStatus = atom({
    key: "HttpStatus",
    default: 200
})

export const initialDrawerState = {
    open: false,
    object: null,
    data: null,
    editors: [],
    activeView: "details",
    pendingRules: [],
    rulesInitialized: false
}

export const createDrawerState = (overrides = {}) => ({
    ...initialDrawerState,
    ...overrides,
    data: overrides.data ?? null,
    editors: overrides.editors ?? [],
    pendingRules: overrides.pendingRules ?? [],
    rulesInitialized: overrides.rulesInitialized ?? false
})

export const DrawerSchema = atom({
    key: "Drawer-schema",
    default: initialDrawerState
})

export const RefetchData = atom({
    key: "RefetchData-schema",
    default: false
})

export const userData = atom({
    key: "user-schema",
    default: { id: "", acesso: "" }
})

export const locais = atom({
    key: "locations",
    default: []
})

export const token = atom({
    key: "theToken",
    default: ""
})
